import { createContext } from 'react';

export type InsuranceType = 'auto' | 'life' | 'disability' | 'home' | null;

export interface InsuranceTypeContextType {
  selectedType: InsuranceType;
  setSelectedType: (type: InsuranceType) => void;
  clearSelection: () => void;
}

export const InsuranceTypeContext = createContext<
  InsuranceTypeContextType | undefined
>(undefined);
